import create from 'zustand'
import { INITIAL_FILTER_PARAMS } from './PatientStore.constants'
import { UsePatientStore } from './PatientStore.types'
import { INITIAL_FORM_DATA } from '../../pages/Patient/components/LinkedPsychologists/components/PsychologistSearch/PsychologistSearch.constants'

const usePatientStore = create<UsePatientStore>(set => ({
  patientId: null,
  professionalId: null,
  attendanceId: null,
  filters: null,
  historyData: null,
  patientData: null,
  selectedPatient: null,
  filter: INITIAL_FILTER_PARAMS,
  currentPage: 1,
  filtersApplied: 0,
  psychologistListData: null,
  psychologistListFilter: INITIAL_FORM_DATA,
  hasScreening: false,
  flagClinicHasPatientPlan: false,
  resetCurrentPage: () =>
    set(state => ({
      ...state,
      currentPage: 1,
    })),
  updateValue(key, value) {
    set(state => ({
      ...state,
      [key]: value,
    }))
  },
}))

export default usePatientStore
